import Head from "next/head";
import Image from "next/image";
import { useRouter } from "next/router";
import React from "react";
import PageName from "../../components/pagename";
import Contact_us from "../../components/contact_us/index";
import Link from "next/link";
import axios from "axios";
import { useTranslations } from "next-intl";

export default function products({ allProducts }) {
  const router = useRouter();
  const t = useTranslations("services");
  return (
    <>
      <Head>
        <title>Products | Ascot Enterprise Solutions</title>
      </Head>
      <div className="">
        <PageName title={t("services")} img="career/Lightbulb" />
        <div className=" xl:m-auto lg:mx-3 mx-3 md:mx-3 max-w-[90rem] responsive">
          <div className="mt-5">
            <div className=" lg:w-2/4">
              <p className="text-[18px] font-[400] leading-[26px] text-[#010140]">
                {t("expertise1")}
                <br />
                {t("expertise2")}
              </p>
            </div>

            <div className="grid grid-cols-12 mx-auto gap-[25px] mt-[48px] mb-[87px] ">
              {allProducts.map((product) => (
                <Link href={`services/${product._id}`}>
                  <div
                    key={product._id}
                    className="cursor-pointer lg:col-span-4 col-span-6  bg-[#FFFFFF] border-[1px] border-[#951B8133] lg:h-48 max-w-[170px] lg:max-w-full min-w-[120px] h-[160px] items-center justify-center flex flex-col lg:gap-8 gap-6 rounded-[10px]"
                  >
                    <div className="lg:h-[65px] lg:w-[65px] w-[50px] h-[50px] relative">
                      <Image
                        src={product.icon}
                        layout="fill"
                        alt="single product"
                        className="object-cover"
                      />
                    </div>
                    {/* <div
                      dangerouslySetInnerHTML={{
                        __html: product?.icon,
                      }}
                    ></div> */}
                    <span className="lg:text-[24px] text-[16px] text-center lg:leading-[24px] leading-[18px] lg:font-[274] font-[510]">
                      {product.iconTitle}
                    </span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
          <Contact_us />
        </div>
      </div>
    </>
  );
}

export async function getServerSideProps(context) {
  const lang = context.locale;
  const productsData = await axios.get(
    `${process.env.NEXT_APP_BACKEND_URL}user/products/all-Products/${lang}`
  );
  const allProducts = productsData?.data?.result;
  return {
    props: {
      allProducts,
      messages: require(`../../locales/${lang || "en"}.json`),
    },
  };
}
